import { rotateArray } from '../../utils/array';
import * as actions from '../actions/player';
import { changeTrack } from '../helpers/player';

import { findIndex, first, last, uniqBy } from 'lodash';
import { reducerWithInitialState } from 'typescript-fsa-reducers';

type Handler<K = undefined> = ReducerHandler<IPlayerState, K>;

type AddTrackToQueueHandler = Handler<IAddTrackToQueueActionPayload>;
type AddTracksToQueueHandler = Handler<IAddTracksToQueueActionPayload>;
type PlayTrackFromQueueHandler = Handler<IPlayTrackFromQueueActionPayload>;
type UpdateElaspedTimeHandler = Handler<IUpdateElaspedTimeActionPayload>;

const defaultList = [];

const initialState: IPlayerState = {
  currentTrack: null,
  history: defaultList,
  isTrackPlaying: false,
  queue: defaultList,
  shouldOnlyPlayOriginalTracks: true,
};

const addTrackToQueueHandler: AddTrackToQueueHandler = (state, { track }) => ({
  ...state,
  queue: [...state.queue, track],
});

const addTracksToQueueHandler: AddTracksToQueueHandler = (state, { tracks, replace }) => {
  const newState: IPlayerState = { ...state };
  newState.queue = replace ? tracks : uniqBy([...state.queue, ...tracks], 'versionId');

  newState.queue.forEach((track) => {
    track.isFirstInQueue = false;
    track.isLastInQueue = false;
  });

  if (newState.queue.length) {
    first(newState.queue)!.isFirstInQueue = true;
    last(newState.queue)!.isLastInQueue = true;
  }

  if (state.currentTrack) {
    const currentTrackIndex = findIndex(newState.queue, { versionId: state.currentTrack.versionId });
    if (currentTrackIndex > -1) {
      newState.queue = rotateArray([...newState.queue], currentTrackIndex + 1);
    }
  }

  return newState;
};

const clearQueueHandler: Handler = (state) => initialState;
const replaceQueueHandler: AddTracksToQueueHandler = (state, { tracks }) =>
  addTracksToQueueHandler(state, { tracks, replace: true });

const playHandler: Handler = (state) => ({ ...state, isTrackPlaying: true });
const pauseHandler: Handler = (state) => ({ ...state, isTrackPlaying: false });
const togglePlayHandler: Handler = (state) => ({ ...state, isTrackPlaying: !state.isTrackPlaying });

const playNextHandler: Handler = (state) => changeTrack(state, 1);
const playPreviousHandler: Handler = (state) => changeTrack(state, -1);
const playTrackFromQueueHandler: PlayTrackFromQueueHandler = (state, { trackId }) => changeTrack(state, trackId);

const updateCurrentTrackElapsedTimeHandler: UpdateElaspedTimeHandler = (state, { elapsedTime }) => ({
  ...state,
  currentTrack: {
    ...state.currentTrack!,
    elapsedTime,
  },
});

const toggleShouldOnlyPlayOriginalTracksHandler: Handler<boolean> = (state, shouldOnlyPlayOriginalTracks) => ({
  ...state,
  shouldOnlyPlayOriginalTracks,
});

export default reducerWithInitialState(initialState)
  .case(actions.addTrackToQueue, addTrackToQueueHandler)
  .case(actions.addTracksToQueue, addTracksToQueueHandler)
  .case(actions.replaceQueue, replaceQueueHandler)
  .case(actions.clearQueue, clearQueueHandler)
  .case(actions.pause, pauseHandler)
  .case(actions.play, playHandler)
  .case(actions.playNext, playNextHandler)
  .case(actions.playPrevious, playPreviousHandler)
  .case(actions.playTrackFromQueue, playTrackFromQueueHandler)
  .case(actions.togglePlay, togglePlayHandler)
  .case(actions.updateCurrentTrackElapsedTime, updateCurrentTrackElapsedTimeHandler)
  .case(actions.toggleShouldOnlyPlayOriginalTracks, toggleShouldOnlyPlayOriginalTracksHandler);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/reducers/player.ts